import React from 'react';
import { Button, Space, Tag } from 'antd';
import { DeleteButton } from '@refinedev/antd';
import { ColumnType } from '@/types';
import { endPoints } from '@/api/configs';
import {
  DeleteOutlined,
  PlayCircleOutlined,
  EditOutlined,
} from '@ant-design/icons';

export const getColumns = (
  translate: (key: string) => string,
  refetch: () => void,
  openEditModal: (topic: {
    id: string;
    name: string;
    sort_order: number;
  }) => void,
  adminType?: string
): ColumnType[] => {
  return [
    {
      title: translate('listing-topics.id'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: translate('listing-topics.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: translate('listing-topics.sort-order'),
      dataIndex: 'sort_order',
      key: 'sort_order',
    },
    {
      title: translate('listing-topics.is_deleted'),
      dataIndex: 'is_deleted',
      key: 'is_deleted',
      render: (is_deleted: boolean) => (
        <Tag color={is_deleted ? 'red' : 'green'}>
          {is_deleted
            ? translate('listing-topics.deleted')
            : translate('listing-topics.not-deleted')}
        </Tag>
      ),
    },
    ...(adminType !== 'ACADEMIC_SUPERVISOR' &&
    adminType !== 'PROGRAM_HEAD' &&
    adminType !== 'SYSTEM_ADMIN'
      ? [
          {
            title: translate('listing-topics.actions'),
            dataIndex: 'actions',
            key: 'actions',
            //@ts-ignore
            render: (_, record) => (
              <Space>
                {!record.is_deleted && (
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => {
                      openEditModal({
                        id: record.id,
                        name: record.name,
                        sort_order: record.sort_order,
                      });
                    }}
                  />
                )}
                <DeleteButton
                  resource={endPoints.topic()}
                  hideText
                  size="small"
                  onSuccess={() => {
                    refetch();
                  }}
                  icon={
                    !record.is_deleted ? (
                      <DeleteOutlined />
                    ) : (
                      <PlayCircleOutlined className="text-green-500" />
                    )
                  }
                  className={
                    record.is_deleted ? 'border-green-500' : 'border-red-500'
                  }
                  successNotification={{
                    message: record.is_deleted
                      ? translate('listing-topics.success.activate-topic')
                      : translate('listing-topics.success.deactivate-topic'),
                    type: 'success',
                  }}
                  danger={!record.is_deleted}
                  recordItemId={record.id}
                  confirmTitle={
                    record.is_deleted
                      ? translate('listing-topics.activate-confirm')
                      : translate('listing-topics.deactivate-confirm')
                  }
                  confirmOkText={
                    record.is_deleted
                      ? translate('listing-topics.activate')
                      : translate('listing-topics.deactivate')
                  }
                />
              </Space>
            ),
          },
        ]
      : []),
  ];
};
